import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader/MainHeader'
import MainFooter from '../../components/MainFooter/MainFooter'
import CTAButton from '../../components/CTAButton/CTAButton'

import './Page404.css'
import './MPage404.css'
import '../../main.css'

import { lP } from '../../main.js'

export default function Page404() {

    return (
        <div className='mainCon' id='mainCon'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Seite nicht gefunden | it.liepert.gmbh</title>
                <meta name="robots" content="noindex, follow" />
                <meta name="description" content="Die angeforderte Seite wurde nicht gefunden." />
            </Helmet>
            <section className='sec_start' id='sec_start--page404'>
                <MainHeader pagetitle="" hideProfile={false} hideMenu={false} />
                {/* <img src={home_start_img} id='sec_start--page404--bgimg' alt="Hintergrundbild der Startseite mit einem verschwommenen Laptop im Hintergrund" /> */}

                <h1>Sie sind wohl dem falschen Navi gefolgt 🤔</h1>
                <h2>ERROR 404 - Seite nicht gefunden</h2>
                <div className='infocontainer'>
                    <p>
                        Kehren Sie entweder zur vorherigen Seite oder zur <a href="/">Startseite</a> zurück.<br />
                        Sollte der Fehler erneut auftreten, kontaktieren Sie uns bitte.<br />
                        Am besten erreichen Sie uns uns über unseren Kontaktbereich<br />
                        oder alternativ per Mail an den Webdesigner <a href="mailto:info@tonetwork.de">info@tonetwork.de</a>.<br />
                        Wir stehen Ihnen gerne zur Seite 😉
                    </p>
                    {/* <img id="repairmanimg" src={hv_repairman} alt="Human-Vektor Grafik" /> */}
                </div>
                <br />
                <CTAButton className='start_cta' title="Zum Kontaktbereich" onclick={() => lP('/kontakt')} darkcta={true} />
                <a href="/" className='backbtn'>Zur Startseite</a>
            </section>
            <MainFooter />
        </div>
    )
}